import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { AuthHeading, BackButton } from 'view/components';
import { AuthHeadingImageTypeEnums } from 'view/pages/auth/helpers';
import { CheckOrVerifyEmail, AuthFormsFooter } from 'view/pages/auth/components';
import { useResendCodeTimer } from 'view/pages/auth/hooks/useResendCodeTimer';
import { useForgotPassword } from 'view/pages/auth/hooks/useForgotPassword';
import * as CS from 'view/pages/auth/commonStyled';

const CheckEmailPage = () => {
  const navigate = useNavigate();
  const { remainingTimeToSendCode, setRemainingTimeToSendCode } = useResendCodeTimer();
  const currentEmail: string = useCS(GlobalConfigContext, globalConfigSelectors.currentEmail);
  const { send } = useForgotPassword();

  useEffect(() => {
    if (!currentEmail) {
      navigate('/auth/onboarding', { replace: true });
    }
  }, [currentEmail]);

  return (
    <CS.Wrapper>
      <CS.BackButtonBox>
        <BackButton text="Back to Forgot Password" fallbackUrl="/auth/forgot" />
      </CS.BackButtonBox>
      <CS.AuthMainBox component="section">
        <AuthHeading title="Check your email" imageType={AuthHeadingImageTypeEnums.CIRCLE} />
        <CS.FormWrapper component="section">
          <CS.FormWrapperMain>
            <CheckOrVerifyEmail
              title="We’ve sent a link to reset your password to"
              currentEmail={currentEmail || ''}
              subtitle={
                'Please check your email and follow the instructions \n to proceed with resetting your password.'
              }
              description="The link will expire in 24 hours."
            />
          </CS.FormWrapperMain>
          <AuthFormsFooter
            title="Don’t receive the email?"
            hrefText="Resend"
            remainingTimeToSendCode={remainingTimeToSendCode}
            setRemainingTimeToSendCode={setRemainingTimeToSendCode}
            send={send}
          />
        </CS.FormWrapper>
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default CheckEmailPage;
